import React from "react";

const TermsAndConditionsOfBook = () => {
  return (
    <div className="w-full">
      {/* Terms Content */}
      <div className=" w-full ">
        {/* terms of service */}
        <h2 className="text-2xl font-bold text-[#c61d21]">Terms of Service</h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          These terms and conditions (" Conditions of Use") apply to you
          (including any person or entity that you are representing) as the user
          of the website www.iskconvijayawada.org ("Website") which is owned,
          operated and managed by ISKCON vijayawada,  ("ISKCON vijayawada ").
          Please read these Conditions of Use carefully before using the
          Website. By using the Website, you signify your agreement to be bound
          by these Conditions of Use.
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          In addition, when you use/ make a request / provide your details on
          the Website or in any other manner enabled by ISKCON vijayawada 
          ("ISKCON vijayawada  offerings"), you will also be subject to the
          terms, guidelines and conditions applicable to such ISKCON vijayawada 
          offerings ("Terms"). If these Conditions of Use are inconsistent with
          such Terms, the Terms will control.
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          These Conditions of Use constitute an electronic record within the
          meaning of applicable laws. This electronic record is generated by a
          computer system and does not require any physical or digital
          signatures. This document is divided into the following three broad
          heads:
        </p>
        <ol className="list-decimal font-['Roboto'] ">
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Conditions Relating to Your Use of the Website.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21] ">
            Procedure for Making Claims of Infringement.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Procedure for Notifying ISKCON vijayawada  of Objectionable Content.
          </li>
        </ol>
      </div>

      {/* Condition  Relating  */}
      <h2 className="text-2xl font-bold text-[#c61d21]">
        Conditions Relating to Your Use of the Website
      </h2>
      <div>
        <ol className="list-decimal font-['Roboto'] ">
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Your Usage:
            <ul>
              If you use the Website, you are responsible for maintaining
              confidentiality of the information you provide us, your account
              and password (where applicable), and for restricting access to
              your computer to prevent any unauthorised access. You agree to
              accept responsibility for all activities that occur under your
              account or password or where you fail to safeguard the information
              you provide us. You should take all necessary steps to ensure that
              the password is kept confidential and secure and should inform us
              immediately if you have any reason to believe that your password
              has become known to anyone else, or if the password is being, or
              is likely to be, used in an unauthorised manner. Please ensure
              that the details you provide us with are correct and complete and
              inform us immediately of any changes to the information. ISKCON
              vijayawada  reserves the right to refuse access to the Website,
              terminate accounts, remove or edit content at any time without
              notice to you.
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21] ">
            Privacy:
            <ul>
              Please review ourPrivacy Policywhich also governs your visit to
              the Website and information you share with us, to understand our
              practices.
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            E-Platform providing details of ISKCON vijayawada  and ISKCON vijayawada
             Offerings:
            <ul>
              You agree, understand and acknowledge that the Website is an
              online platform that provides you with details about ISKCON vijayawada
               and ISKCON vijayawada  Offerings.
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Access to the Website:
            <ul>
              We will do our utmost to ensure that availability of the Website
              will be uninterrupted and that transmissions will be error-free.
              However, due to the nature of the internet, this cannot be
              guaranteed. Also, your access to the Website may also be
              occasionally suspended or restricted to allow for repairs,
              maintenance, or introduction of new facilities or features at any
              time without prior notice. We will attempt to limit the frequency
              and duration of any such suspension or restriction.
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            License for Website Access:
            <ul>
              Subject to compliance with these Conditions of Use, ISKCON vijayawada
               grants you a limited license to access and make personal
              use of the Website, but not to download (other than page caching)
              or modify it, or any portion of it, except with express written
              consent of ISKCON vijayawada . This license does not contemplate
              any resale or commercial use of this Website or its contents; any
              derivative use of this Website or its contents; any downloading or
              copying of account information; or any use of data mining, robots,
              or similar data gathering and extraction tools.
              <br />
              <br />
              This Website or any portion hereof (including but not limited to
              any copyrighted material, trademarks, or other proprietary
              information) shall not be reproduced, duplicated, copied, sold,
              resold, visited, distributed or otherwise exploited for any
              commercial purpose without express written consent of ISKCON vijayawada
              .
              <br />
              <br />
              You shall not frame or use framing techniques to enclose any
              trademark, logo, or other proprietary information (including
              images, text, page layout or form) of ISKCON vijayawada . You
              shall not use any meta tags or any other "hidden text" utilising
              ISKCON vijayawada 's name or trademarks without the express
              written consent of ISKCON vijayawada . Any unauthorised use
              terminates the permission or license granted by Amoh.
              <br />
              <br />
              You are granted a limited, revocable, and non-exclusive right to
              create a hyperlink to the Welcome page of the Website as long as
              the link does not portray ISKCON vijayawada  and/or its associates
              / affiliates / parent company / directors / officers / employees /
              agents / successors / assigns, or Amoga Offerings in a false,
              misleading, derogatory, or otherwise offensive matter. You may not
              use any ISKCON vijayawada  logo or other proprietary graphic or
              trademark as part of the link without express written consent of
              ISKCON vijayawada .
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Your Conduct:
            <ul
              className=" font-['Roboto'] "
              style={{
                listStyleType: "lower-alpha",
              }}
            >
              You must not use the Website in any way that causes, or is likely
              to cause, the Website or access to it to be interrupted, damaged
              or impaired in any way. You understand that you, and not ISKCON
              vijayawada , are responsible for all electronic communications and
              content sent from your computer to us and you must use the Website
              for lawful purposes only. You must not use the Website for any of
              the following purposes:
              <br />
              <br />
              <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21] ml-5">
                For fraudulent purposes, or in connection with a criminal
                offense or other unlawful activity;
              </li>
              <br />
              <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21] ml-5">
                To send, use or reuse any information / material that does not
                belong to you; or is illegal, offensive (including but not
                limited to material that is sexually explicit content or which
                promotes racism, bigotry, hatred or physical harm), deceptive,
                misleading, abusive, indecent, harassing, blasphemous,
                defamatory, libelous, obscene, pornographic, pedophilic or
                menacing; ethnically objectionable, disparaging or in breach of
                copyright, trademark, confidentiality, privacy or any other
                proprietary information or right; or is otherwise injurious to
                third parties; or relates to or promotes money laundering or
                gambling; or is harmful to minors in any way; or impersonates
                another person; or threatens the unity, integrity, security or
                sovereignty of India or friendly relations with foreign States;
                or objectionable or otherwise unlawful in any manner whatsoever;
                or which consists of or contains software viruses, political
                campaigning, commercial solicitation, chain letters, mass
                mailings or any "spam"; or
              </li>
              <br />
              <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21] ml-5">
                To cause annoyance, inconvenience or needless anxiety.
              </li>
              <br />
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Communications and other Content shared with ISKCON vijayawada :
            <ul
              className=" font-['Roboto'] "
              style={{
                listStyleType: "lower-alpha",
              }}
            >
              Users of the Website may transmit information, requests, and other
              content; send communications; and submit suggestions, ideas,
              comments, questions, or other information as long as the content
              is not illegal, obscene, abusive, threatening, defamatory,
              invasive of privacy, infringing of intellectual property rights,
              or otherwise injurious to third parties, or objectionable and does
              not consist of or contain software viruses, political campaigning,
              commercial solicitation, chain letters, mass mailings, or any form
              of "spam". In the event a user uses a false e-mail address,
              impersonates any person or entity, or otherwise misleads as to the
              origin of any content, ISKCON vijayawada  reserves the right (but
              not the obligation) to remove, refuse, delete or edit any content
              that, in the sole judgment of ISKCON vijayawada , violates these
              Conditions of Use and/or terminate the user’s permission to access
              or use the Website.
              <br />
              <br />
              If you do transmit content or submit material, and unless we
              expressly indicate otherwise, you grant:
              <br />
              <br />
              <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21] ml-5">
                ISKCON vijayawada  and its affiliates a non-exclusive,
                royalty-free, irrevocable, perpetual and fully sub-licensable
                rights to use, reproduce, modify, adapt, publish, translate,
                create derivative works from, distribute, and display such
                content throughout the world in any media; and
              </li>
              <br />
              <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21] ml-5">
                ISKCON vijayawada  and its affiliates and sub-licensees the
                right to use the name that you submit in connection with such
                content, if we choose.
              </li>
              <br />
              You represent and warrant that you own or otherwise control all of
              the rights to the content that you transmit or that you otherwise
              provide on or through the Website; that, as at the date that the
              content or material is submitted to ISKCON vijayawada : (i) the
              content and material is accurate; (ii) use of the content and
              material you supply does not breach any applicable ISKCON vijayawada
               policies or guidelines and will not cause injury to any
              person or entity (including that the content or material is not
              defamatory); (iii) the content is lawful. You agree to indemnify
              ISKCON vijayawada  and its affiliates for all claims brought by a
              third party against it or its affiliates arising out of or in
              connection with a breach of any of these warranties.
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Claims against Objectionable Content:
            <ul>
              If you believe that any content on the Website is illegal,
              offensive (including but not limited to material that is sexually
              explicit content or which promotes racism, bigotry, hatred or
              physical harm), deceptive, misleading, abusive, indecent,
              harassing, blasphemous, defamatory, libellous, obscene,
              pornographic, paedophilic or menacing; ethnically objectionable,
              disparaging; or is otherwise injurious to third parties; or
              relates to or promotes money laundering or gambling; or is harmful
              to minors in any way; or impersonates another person; or threatens
              the unity, integrity, security or sovereignty of India or friendly
              relations with foreign States; or objectionable or otherwise
              unlawful in any manner whatsoever; or which consists of or
              contains software viruses ("Objectionable Content"), please notify
              us immediately by following the procedure laid down in the
              ‘Procedure for Notifying ISKCON vijayawada  of Objectionable
              Content’ section below. Once this procedure has been followed,
              ISKCON vijayawada  will make all reasonable endeavours to remove
              such Objectionable Content complained about within a reasonable
              time.
            </ul>
          </li>

          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Copyright, authors' rights and database rights:
            <ul>
              All content included on the Website, such as text, graphics,
              logos, button icons, images, audio clips, digital downloads, data
              compilations, and software, is the property of ISKCON vijayawada ,
              or its content suppliers and is protected by Indian and
              international intellectual property rights laws including
              copyright, authors' rights and database right laws. The
              compilation of all content on this Website is the exclusive
              property of ISKCON vijayawada  and its affiliates and is protected
              by laws of India and international intellectual property rights
              laws including copyright and database right laws. All software
              used on this Website is the property of Amoga, its affiliates or
              its software suppliers and is protected by Indian and
              international intellectual property rights laws including
              copyright and author' rights laws.
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Claims against Objectionable Content:
            <ul>
              If you believe that any content on the Website is illegal,
              offensive (including but not limited to material that is sexually
              explicit content or which promotes racism, bigotry, hatred or
              physical harm), deceptive, misleading, abusive, indecent,
              harassing, blasphemous, defamatory, libellous, obscene,
              pornographic, paedophilic or menacing; ethnically objectionable,
              disparaging; or is otherwise injurious to third parties; or
              relates to or promotes money laundering or gambling; or is harmful
              to minors in any way; or impersonates another person; or threatens
              the unity, integrity, security or sovereignty of India or friendly
              relations with foreign States; or objectionable or otherwise
              unlawful in any manner whatsoever; or which consists of or
              contains software viruses ("Objectionable Content"), please notify
              us immediately by following the procedure laid down in the
              ‘Procedure for Notifying ISKCON vijayawada  of Objectionable
              Content’ section below. Once this procedure has been followed,
              ISKCON vijayawada  will make all reasonable endeavours to remove
              such Objectionable Content complained about within a reasonable
              time.
              <br />
              <br />
              You may not systematically extract/ or re-utilise parts of the
              contents of the Website without ISKCON vijayawada 's and/ or its
              affiliates (as may be applicable) express written consent. In
              particular, you may not utilise any data mining, robots, or
              similar data gathering and extraction tools to extract (whether
              once or many times) for re-utilisation of any substantial parts of
              this Website, without ISKCON vijayawada ’s and/or its affiliates
              (as may be applicable) express written consent. You may also not
              create and/ or publish your own database that features substantial
              parts of this Website without ISKCON vijayawada 's and/ or its
              affiliates (as may be applicable) express written consent.
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Intellectual Property Claims:
            <ul>
              ISKCON vijayawada  respects the intellectual property of others.
              If you believe that your intellectual property rights have been
              used in a way that gives rise to concerns of infringement, please
              follow the procedure laid down in the ‘Procedure for Making Claims
              of Right Infringements’ section below.
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Trademarks:
            <ul>
              ISKCON vijayawada  and other marks indicated on our website are
              trademarks/ registered trademarks of ISKCON vijayawada  and other
              entities which have authorized ISKCON vijayawada  to use such
              trademarks. ISKCON vijayawada 's graphics, logos, page headers,
              button icons, scripts and service names are the trademarks or
              trade dress of Amoga. ISKCON vijayawada  trademarks and trade
              dress may not be used in connection with any product or service
              that is not ISKCON vijayawada 's, in any manner that is likely to
              cause confusion, or in any manner that disparages or discredits
              ISKCON vijayawada . Any usage of ISKCON vijayawada 's trademarks,
              logos, page headers, button icons, scripts and service names
              require prior written approval and such usage is subject to the
              guidelines that may be prescribed by ISKCON vijayawada . All other
              trademarks not owned by ISKCON vijayawada  that appear on this
              Website are the property of their respective owners, who may or
              may not be associated with, connected to, or sponsored by ISKCON
              vijayawada .
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Disclaimer:
            <ul>
              You acknowledge and undertake that you are accessing ISKCON vijayawada
               Offerings at your own risk and are using your best and
              prudent judgment before accessing this Website. We shall neither
              be liable nor responsible for any actions or inactions of other
              third parties nor any breach of conditions, representations or
              warranties by any third parties (whether or not with respect to
              the use of the Website) and hereby expressly disclaim any and all
              responsibility and liability in that regard. You also acknowledge
              and agree that ISKCON vijayawada  does not guarantee any formal
              engagement with you in response to the information provided /
              request made by you on the Website including for the purposes of
              making a job application, or requesting for vendor on boarding or
              for any other purpose.
            </ul>
          </li>

          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Indemnity and Release:
            <ul>
              You shall indemnify and hold harmless ISKCON vijayawada , its
              subsidiaries, affiliates, associates and their respective
              officers, directors, agents and employees, from any claim or
              demand, or actions including reasonable attorney's fees, made by
              any third party or penalty imposed due to or arising out of your
              breach of these Conditions of Use or any document incorporated by
              reference, or your violation of any law, rules, regulations or the
              rights of a third party.
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Children:
            <ul>
              Use of the Website is available only to persons who can form a
              legally binding contract under the Indian Contract Act, 1872. If
              you are a minor i.e. under the age of 18 years, you may use the
              Website only with the involvement of a parent or guardian.
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Other Businesses:
            <ul>
              We may provide links to the websites of other companies and
              certain other businesses. We are not responsible for examining or
              evaluating, and we do not warrant or endorse the offerings of any
              of these businesses or individuals, or the content of their
              websites. ISKCON vijayawada  does not assume any responsibility or
              liability for the actions, products, and content of any of these
              and any other third-parties. You should carefully review their
              privacy statements and other conditions of use.
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Communications:
            <ul>
              When you visit the Website or provide information on the Website
              or send e-mails to us, you are communicating with us
              electronically. You may be required to provide a valid phone
              number while making such communications. We may communicate with
              you by e-mail, SMS, phone call or by posting notices on the
              Website or by any other mode of communication. For contractual
              purposes, you consent to receive such communications from us.
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Losses:
            <ul>
              We will not be responsible for any business loss (including loss
              of profits, revenue, contracts, anticipated savings, data,
              goodwill or wasted expenditure) or any other indirect or
              consequential loss on account of your usage of the Website or for
              any reason arising there from or connected therewith.
              <br />
              <br />
              Alteration of Service or Amendments to the Conditions: We reserve
              the right to make changes to our Website, policies, and these
              Conditions of Use at any time. You will be subject to the policies
              and Conditions of Use in force at the time that you use the
              Website, unless any change to those policies or these conditions
              is required to be made by law or government authority (in which
              case such change will apply to your use of the Website). If any of
              these Conditions of Use is deemed invalid, void, or for any reason
              unenforceable, that condition will be deemed severable and will
              not affect the validity and enforceability of any remaining
              condition.
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Events beyond our reasonable control:
            <ul>
              We will not be held responsible for any delay or failure to comply
              with our obligations under these Conditions of Use if the delay or
              failure arises from any cause which is beyond our reasonable
              control. This condition does not affect your statutory rights.
            </ul>
          </li>

          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Waiver:
            <ul>
              If you breach these Conditions of Use and we take no action, we
              will still be entitled to use our rights and remedies in any other
              situation where you breach these Conditions of Use.
            </ul>
          </li>

          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Governing Law and Jurisdiction:
            <ul>
              These Conditions of Use are governed by and construed in
              accordance with the laws of India. You agree, as we do, to submit
              any and all disputes, differences, disagreements, by whatever name
              called, arising out of or in relation hereto, to the exclusive
              jurisdiction of the courts at Delhi.
            </ul>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Our Details:
            <ul>
              This website is operated by ISKCON vijayawada, Hare Krishna Land, 
              400049 or such other entity who may be authorized by ISKCON vijayawada,
              Hare Krishna Land,  400049
            </ul>
          </li>
        </ol>
      </div>
      <div>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          Procedure for making claims of right infringements
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          If you believe that your rights are being violated/ infringed by the
          Website or any content published thereon, you may contact the
          info@iskcon.comas per the details stated below, by a
          communication with the subject line "Claim of Infringement". Please
          provide your address, telephone number, and e-mail address when
          sending the notice to us. We will attempt to respond about any alleged
          infringement within 30 (thirty) days from the receipt of such
          communication from you with all the necessary details/ documents.
        </p>

        <p className="text-start font-['Roboto'] text-black text-lg">
          Important Warning: Giving false, misleading or inaccurate information
          in the communication to ISKCON vijayawada  may result in civil and/or
          criminal liability. You should contact a legal advisor should you have
          any questions.
        </p>

        <p className="text-start font-['Roboto'] text-black text-lg">
          Procedure for notifying ISKCON vijayawada  of objectionable content
        </p>

        <p className="text-start font-['Roboto'] text-black text-lg">
          If you notice any objectionable content on this Website please write
          to info@iskcon.com
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditionsOfBook;
